/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================
*/

// Material Kit 2 React pages
import AboutOurCompany from "pages/LandingPages/AboutOurCompany";

export default function AboutOurCompanyPage() {
  return <AboutOurCompany />;
}
